import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCog, FaUsers, FaFileInvoiceDollar, FaFileContract, FaHandshake, FaFileMedical, FaUniversity, FaChartLine, FaFileCsv, FaChild } from 'react-icons/fa';
import '../../styles/pages/RRHH/RRHHPage.css';

/**
 * Página principal del módulo de Recursos Humanos
 * Muestra menú con todas las opciones del módulo
 */
const RRHHPage = ({ id_company }) => {
    const navigate = useNavigate();

    const menuItems = [
        {
            title: 'Parámetros Empresa',
            description: 'Configuración de parámetros de RRHH',
            icon: <FaCog />,
            path: '/rrhh/parametros'
        },
        {
            title: 'Colaboradores',
            description: 'Gestión de empleados y trabajadores',
            icon: <FaUsers />,
            path: '/rrhh/colaboradores'
        },
        {
            title: 'Liquidaciones de Sueldo',
            description: 'Liquidaciones mensuales de remuneraciones',
            icon: <FaFileInvoiceDollar />,
            path: '/rrhh/liquidaciones'
        },
        {
            title: 'Previred',
            description: 'Declaraciones y archivos Previred',
            icon: <FaUniversity />,
            path: '/rrhh/previred'
        },
        {
            title: 'Indicadores Previsionales',
            description: 'Indicadores Previred mensuales',
            icon: <FaChartLine />,
            path: '/rrhh/indicadores-previred'
        },
        {
            title: 'Cargas Familiares',
            description: 'Cargas y tramos autorizados por el IPS (Excel Previred)',
            icon: <FaChild />,
            path: '/rrhh/cargas-familiares'
        },
        {
            title: 'Contratos',
            description: 'Contratos de trabajo',
            icon: <FaFileContract />,
            path: '/rrhh/contratos'
        },
        {
            title: 'Finiquitos',
            description: 'Finiquitos de término de contrato',
            icon: <FaHandshake />,
            path: '/rrhh/finiquitos'
        },
        {
            title: 'Licencias Médicas',
            description: 'Gestión de licencias médicas',
            icon: <FaFileMedical />,
            path: '/rrhh/licencias-medicas'
        },
        {
            title: 'DT - Archivos CSV',
            description: 'Generación de archivos CSV para la DT',
            icon: <FaFileCsv />,
            path: '/rrhh/dt'
        }
    ];

    return (
        <div className="rrhh-container">
            <div className="rrhh-header">
                <h1>Recursos Humanos</h1>
                <p>Gestión integral de personal y remuneraciones</p>
            </div>

            <div className="rrhh-menu-grid">
                {menuItems.map((item, index) => (
                    <div
                        key={index}
                        className="rrhh-menu-card"
                        onClick={() => navigate(item.path)}
                    >
                        <div className="rrhh-card-icon">
                            {item.icon}
                        </div>
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RRHHPage;
